module.exports = __webpack_public_path__ + "static/media/change-diet-icon.bbb4e1a9.svg";